import React from "react";

function LatestMatch() {
  return (
    <section className="latest-match-area latest-match-bg pt-115 pb-90">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title title-style-three white-title text-center mb-70">
              <h2>What we are <span>capable of</span></h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                  style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                  src="assets/img/images/Gamesguru - Mobile game design.png"
                  alt=""
                />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >
                  Mobile <span>Game Design</span>{" "}
                </h3>
                <p className="md-text-center" >
                  Chetu is a game development company, proficient in building
                  role-playing games (RPGs), casino, racing, adventure,
                  e-learning, sports, and other games designed and coded to play
                  on Android and iOS devices.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                 style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                src="assets/img/images/Gamesguru - Animation.png" alt="" />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >
                 Mobile Game <span>Animation</span>{" "}
                </h3>
                <p className="md-text-center" >
                  Our in-house team of game animators leverage industry-standard
                  tools, like Blender and Maya to model and animate realistic
                  game characters, environments, and other details.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                 style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                  src="assets/img/images/Gamesguru - mobile social.png"
                  alt=""
                />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >
                  {" "}
                 Mobile Social <span> Gaming Development</span>{" "}
                </h3>
                <p className="md-text-center" >
                  We are a game development company that creates interactive
                  mobile apps using a device's inherent hardware with integrated
                  social media APIs to build engaging social games for mobile
                  platforms.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img 
                 style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}  
                src="assets/img/images/Gamesguru - Console.png" alt="" />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >
                  {" "}
                Console <span>Based Gaming </span>
                </h3>
                <p className="md-text-center" >
                  Engineer cross-platform mobile AR & VR gaming solutions using
                  popular programming languages, such as C++, Java, JavaScript,
                  Python, Swift, and Kotlin.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LatestMatch;
